import { CalendarEventsSidenavComponent } from '@modules/calendar/modules/calendar-events-sidenav/components/calendar-events-sidenav/calendar-events-sidenav.component';
import { TaskSidenavComponent } from '@shared/modules/task-sidenav/components/task-sidenav/task-sidenav.component';
import { EventSidenavComponent } from '@shared/modules/event-sidenav/components/event-sidenav/event-sidenav.component';
import { MailingSidenavComponent } from '@modules/mailing-templates/shared/modules/mailing-sidenav/components/mailing-sidenav/mailing-sidenav.component';
import { ProjectCreatorEntitySidenavComponent } from '@modules/project-creator/shared/modules/project-creator-entity-sidenav/components/project-creator-entity-sidenav/project-creator-entity-sidenav.component';
import { ContactSidenavComponent } from '@shared/modules/contact-sidenav/components/contact-sidenav/contact-sidenav.component';
import { ProjectsTimelineSidenavComponent } from '@modules/projects/shared/components/projects-timeline-sidenav/projects-timeline-sidenav.component';

export const SidenavRouteComponents = {
  'project-creator-entity': ProjectCreatorEntitySidenavComponent,
  'week-events': CalendarEventsSidenavComponent,
  task: TaskSidenavComponent,
  event: EventSidenavComponent,
  mailing: MailingSidenavComponent,
  contact: ContactSidenavComponent,
  projecttimeline: ProjectsTimelineSidenavComponent
};
